import {
  useInboxFilterDocument,
  useUpdateInboxFilterDocument,
} from 'features/user';
import React from 'react';
import { FilterDocuments } from 'shared/constants';
import { useInboxCustomOrderByGrouping } from 'shared/hooks/use-inbox-custom-order-by-grouping';
import { useInboxOnReorder } from 'shared/hooks/use-inbox-on-reorder';
import { useInboxOnSectionCollapse } from 'shared/hooks/use-inbox-on-section-collapse';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

type TasksListProps = {
  scrollRef: React.RefObject<HTMLDivElement>;
};

export const TasksList: React.FC<TasksListProps> = ({ scrollRef }) => {
  const filterDocument = useInboxFilterDocument();
  const updateInboxFilterDocument = useUpdateInboxFilterDocument();

  const customOrder = useInboxCustomOrderByGrouping(filterDocument.groupByMode);
  const updateCustomOrder = useInboxOnReorder(filterDocument.groupByMode);
  const updateCollapsedSections = useInboxOnSectionCollapse();

  const onReset = () =>
    updateInboxFilterDocument(FilterDocuments.Inbox.defaultFilterDocument);

  return (
    <ProvidedTaskFilterList
      scrollElement={scrollRef}
      filterDocument={filterDocument}
      customOrder={customOrder}
      onReorder={updateCustomOrder}
      onSectionCollapse={updateCollapsedSections}
      onReset={onReset}
      defaultFilterDocument={FilterDocuments.Inbox.defaultFilterDocument}
    />
  );
};
